import { __awaiter } from "tslib";
import { FileType } from "@ms-ofb/officefloodgatecore/dist/src/Api/IFloodgateStorageProvider";
import { TargetedMessagingTransport } from "./TargetedMessagingTransport";
import { buildQueryParameters } from "../Common/UrlUtils";
import { TargetedMessagingCache } from "./TargetedMessagingCache";
import * as Constants from "../Constants";
import * as Logging from "../Logging/Logging";
import * as TmsgConstants from "./TargetedMessagingConstants";
import { getDynamicSetting } from "../Configuration/DynamicConfiguration";
import FloodgateStorageProvider from "../FloodgateCore/FloodgateStorageProvider";
import { TMS_SERVICE_ACTION_URL } from "./TargetedMessagingConstants";
import { getAugLoopAnnotationData } from "./AugLoopHelper";
export class ContentResponse {}
export function getDebugCampaignDefinitions() {
  const debugOverrides = FloodgateStorageProvider.safeReadObject(FileType.DebugOverrides, {});
  return debugOverrides && debugOverrides.tmsResponse && debugOverrides.tmsResponse.CampaignContent && {
    contentType: "CampaignContent" /* campaignContent */,
    content: debugOverrides.tmsResponse.CampaignContent
  };
}
export function getDebugUserFacts() {
  const debugOverrides = FloodgateStorageProvider.safeReadObject(FileType.DebugOverrides, {});
  return debugOverrides && debugOverrides.userFactsResponse && {
    contentType: "UserFacts" /* userFacts */,
    content: debugOverrides.userFactsResponse
  };
}
export class TargetedMessagingClient {
  constructor(app, platform, version, locale, country, sessionId, authTokenCallback, augLoopCallback, campaignFlights, campaignParameters, ageGroup, authenticationType, tmsgCacheIn) {
    this.locale = "en-us";
    this.country = "US";
    this.locale = locale;
    this.country = country;
    this.authTokenCallback = authTokenCallback;
    this.augLoopCallback = augLoopCallback;
    this.app = app;
    this.platform = platform;
    this.version = version;
    this.sessionId = sessionId;
    this.campaignFlights = campaignFlights;
    this.campaignParameters = campaignParameters;
    this.ageGroup = ageGroup;
    this.authenticationType = authenticationType;
    this.tmsgCache = this.tmsgCache || tmsgCacheIn || new TargetedMessagingCache(["MessageMetadata" /* messageMetadata */, "UserGovernance" /* userGovernanceRules */, "CampaignContent" /* campaignContent */, "DynamicSettings" /* dynamicSettings */, "LogLevelSettings" /* logLevelSettings */, "UserFacts" /* userFacts */]);
  }
  getContent(requestedContent) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.tmsgCache.isItemExpired(requestedContent)) {
        yield this.refreshItemsInCacheFromTmsService([requestedContent]);
      }
      const response = this.retrieveCacheItemAndCreateContentResponse(requestedContent);
      return response;
    });
  }
  getMultipleContents(requestedContent) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.refreshItemsInCacheFromTmsService(requestedContent);
      const contentResponses = new Array();
      const bulkRefreshList = new Array();
      for (let contentType of requestedContent) {
        const responseItem = this.createCachedContentResponse(contentType);
        contentResponses.push(responseItem);
      }
      this.refreshItemsInCacheFromTmsService(bulkRefreshList);
      return contentResponses;
    });
  }
  getUserFactsContent(requestedContent) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.refreshItemsInCacheFromTulipsService(requestedContent);
      const response = this.retrieveCacheItemAndCreateContentResponse(requestedContent);
      return response;
    });
  }
  sendBeaconRequestToService(app, beaconParameters, platform, version, locale, country, sessionId, authTokenCallback) {
    return __awaiter(this, void 0, void 0, function* () {
      this.sessionId = sessionId;
      this.authTokenCallback = authTokenCallback;
      const tmsAppId = getDynamicSetting("TmsAppId" /* tmsAppId */, Constants.GUIDs.TMSAppID);
      const authToken = yield this.getAuthToken(tmsAppId);
      let puid = undefined;
      if (!authToken) {
        puid = this.authTokenCallback.getUserPuid && (yield this.authTokenCallback.getUserPuid());
      }
      const requestStartTime = +new Date();
      try {
        const tmsQueryParams = {
          app,
          country,
          locale,
          platform,
          puid,
          version
        };
        const requestBody = JSON.stringify({
          actionName: beaconParameters.actionName,
          actionUrl: beaconParameters.actionUrl
        });
        const response = yield this.sendRequest(tmsQueryParams, authToken, "TmsActionUrl" /* tmsActionUrl */, TMS_SERVICE_ACTION_URL, requestBody, "POST");
        if (!response || response.status !== 200) {
          Logging.getLogger().logEvent(Logging.EventIds.WebSurfaces.Common.Error.VALUE, 2 /* Error */, this.createTelemetryData(requestStartTime, response, `Beacon${beaconParameters.actionName}`));
          return false;
        }
        return true;
      } catch (error) {
        Logging.getLogger().logEvent(Logging.EventIds.WebSurfaces.Common.Error.VALUE, 2 /* Error */, Object.assign({
          ErrorMessage: "Error fetching from TMS SetCampaignAction endpoint" + (error && error.message ? ": " + error.message : "")
        }, this.createTelemetryData(requestStartTime, null, `Beacon${beaconParameters.actionName}`)));
        return false;
      }
    });
  }
  getCachedContent(requestedContent) {
    return this.tmsgCache.getItemContent(requestedContent);
  }
  getAugLoopUserFactsContent(requestedContent) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.tmsgCache.isItemExpired("UserFacts" /* userFacts */)) {
        yield this.refreshUserFactsInCacheFromAugLoop();
      }
      const response = this.retrieveCacheItemAndCreateContentResponse(requestedContent);
      return response;
    });
  }
  refreshUserFactsInCacheFromAugLoop() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.tmsgCache.isItemExpired("UserFacts" /* userFacts */)) {
        const cachedUserFacts = this.tmsgCache.getItemContent("UserFacts" /* userFacts */);
        Logging.getLogger().logEvent(Logging.EventIds.UserFacts.AugLoop.Requests.VALUE, 3 /* Info */, {
          Count: cachedUserFacts ? cachedUserFacts.length : -1,
          Type: "AugLoopUserFactsCached",
          Flights: this.campaignFlights
        });
        return cachedUserFacts;
      }
      const requestStartTime = +new Date();
      let userFacts;
      try {
        const annotationName = getDynamicSetting("TulipsAugLoopAnnotationName" /* tulipsAugLoopAnnotationName */, "AugLoop_User_UserLifecycleFactsAnnotation");
        const augLoopSessionPromise = this.augLoopCallback.getRuntimeSession;
        const response = yield getAugLoopAnnotationData(annotationName, augLoopSessionPromise);
        if (response && response.userFacts) {
          userFacts = this.addClientIngestionTimeAndNormalizeKeysInArray(response.userFacts);
          this.tmsgCache.setContentItem("UserFacts" /* userFacts */, userFacts, TmsgConstants.CACHE_EXPIRY_USERFACTS);
          Logging.getLogger().logEvent(Logging.EventIds.UserFacts.AugLoop.Requests.VALUE, 3 /* Info */, Object.assign({
            Count: userFacts ? userFacts.length : -1
          }, this.createTelemetryData(requestStartTime, null, "AugLoopUserFacts")));
        } else {
          const augLoopError = response && response.error;
          Logging.getLogger().logEvent(Logging.EventIds.UserFacts.AugLoop.Error.VALUE, 2 /* Error */, Object.assign({
            ErrorMessage: "Error getting augloop facts " + (augLoopError && augLoopError.toString())
          }, this.createTelemetryData(requestStartTime, null, "AugLoopUserFacts")));
        }
      } catch (error) {
        Logging.getLogger().logEvent(Logging.EventIds.UserFacts.AugLoop.Error.VALUE, 2 /* Error */, Object.assign({
          ErrorMessage: "Error getting facts " + (error && error.message)
        }, this.createTelemetryData(requestStartTime, null, "AugLoopUserFacts")));
      }
      return userFacts;
    });
  }
  createTelemetryData(requestStartTimestamp, response, type) {
    const {
      headers,
      status,
      statusText
    } = response || {};
    const serverSessionId = headers && headers.get("X-UserSessionId");
    const serverCorrelationId = headers && headers.get("X-CorrelationId");
    return {
      Type: type,
      TimeMilliseconds: +new Date() - requestStartTimestamp,
      SessionId: serverSessionId || this.sessionId,
      CorrelationId: serverCorrelationId || undefined,
      HttpStatusCode: status || undefined,
      HttpStatusText: statusText || undefined,
      Flights: this.campaignFlights
    };
  }
  sendRequest(tmsgQueryParams, authToken, key, serviceUrl, requestBody, verb) {
    this.tmsgTransport = this.tmsgTransport || new TargetedMessagingTransport(this.sessionId);
    const queryParamStr = buildQueryParameters(tmsgQueryParams);
    const tmsgBaseUrl = getDynamicSetting(key, serviceUrl);
    const requestPromise = verb === "POST" ? this.tmsgTransport.sendPostRequest(tmsgBaseUrl + queryParamStr, requestBody, authToken) : this.tmsgTransport.sendGetRequest(tmsgBaseUrl + queryParamStr, authToken);
    return requestPromise;
  }
  retrieveCacheItemAndCreateContentResponse(contentType) {
    const responseItem = this.createCachedContentResponse(contentType);
    if (this.tmsgCache.isItemExpired(contentType)) {
      if (contentType === "UserFacts" /* userFacts */) {
        this.refreshItemsInCacheFromTulipsService(contentType);
      } else {
        this.refreshItemsInCacheFromTmsService([contentType]);
      }
    }
    return responseItem;
  }
  createCachedContentResponse(requestedContent) {
    const contentResponse = new ContentResponse();
    contentResponse.content = this.tmsgCache.getItemContent(requestedContent);
    contentResponse.contentType = requestedContent;
    return contentResponse;
  }
  getAuthToken(appIdOrUri) {
    return __awaiter(this, void 0, void 0, function* () {
      var _this = this;
      if (!this.authTokenCallback || !this.authTokenCallback.getAuthToken) {
        return null;
      }
      const startTime = +new Date();
      const getDuration = () => +new Date() - startTime;
      const createAuthTelemetryData = function () {
        let errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        return {
          ErrorMessage: errorMessage,
          SessionId: _this.sessionId,
          TimeMilliseconds: getDuration(),
          Type: appIdOrUri
        };
      };
      try {
        const retVal = yield this.authTokenCallback.getAuthToken(appIdOrUri);
        Logging.getLogger().logEvent(Logging.EventIds.WebSurfaces.Common.Info.VALUE, 3 /* Info */, createAuthTelemetryData());
        return retVal;
      } catch (error) {
        Logging.getLogger().logEvent(Logging.EventIds.WebSurfaces.Common.Error.VALUE, 2 /* Error */, createAuthTelemetryData("Error getting token " + (error && error.message ? ": " + error.message : "")));
      }
      return null;
    });
  }
  refreshItemsInCacheFromTmsService(contentTypes) {
    return __awaiter(this, void 0, void 0, function* () {
      if (contentTypes.length === 0) {
        return;
      }
      // check if touched items are actually due for refresh or are still valid
      const bulkRefreshList = new Array();
      for (let contentType of contentTypes) {
        if (this.tmsgCache.isItemExpired(contentType)) {
          bulkRefreshList.push(contentType);
        }
      }
      if (bulkRefreshList.length === 0) {
        // exit out if all items in cache are still valid to avoid unnecessary service roundtrips 
        return;
      }
      // always request for dynamic settings
      if (contentTypes.indexOf("DynamicSettings" /* dynamicSettings */) === -1) {
        contentTypes.push("DynamicSettings" /* dynamicSettings */);
      }
      // get auth token or user id
      const tmsAppId = getDynamicSetting("TmsAppId" /* tmsAppId */, Constants.GUIDs.TMSAppID);
      const authToken = yield this.getAuthToken(tmsAppId);
      let userPuid = undefined;
      if (!authToken) {
        userPuid = this.authTokenCallback.getUserPuid && (yield this.authTokenCallback.getUserPuid());
      }
      const requestStartTime = +new Date();
      // make service call for expired or uncached items
      try {
        // capture browser data to perform additional filters on IRIS
        // this is to avoid showing bad UI experience on unsupported browsers/dimensions
        const documentElement = document && (document.documentElement || document.getElementsByTagName("body")[0]);
        const browserParams = {
          pageWidth: window.innerWidth || documentElement.clientWidth,
          pageHeight: window.innerHeight || documentElement.clientHeight,
          screenWidth: screen ? screen.width : undefined,
          screenHeight: screen ? screen.height : undefined,
          colorDepth: screen ? screen.colorDepth : undefined
        };
        // allow testing with query param overrides with key obf-DebugOverrides
        // eg: {"addTmsQueryParams":{"key1":"key1value"},"replaceTmsQueryParams":{"key2":"key2value"}, "tmsResponse": {}}
        const debugOverrides = FloodgateStorageProvider.safeReadObject(FileType.DebugOverrides, {});
        const tmsQueryParams = debugOverrides.replaceTmsQueryParams || Object.assign(Object.assign({
          country: this.country,
          locale: this.locale,
          app: this.app,
          platform: this.platform,
          version: this.version,
          campaignParams: buildQueryParameters(browserParams) + "&more=true&" + (this.campaignParameters || ""),
          contentType: contentTypes.join(";"),
          puid: userPuid,
          OFC_FLIGHTS: this.campaignFlights
        }, debugOverrides.addTmsQueryParams || {}), {
          ageGroup: this.ageGroup,
          authenticationType: this.authenticationType
        });
        const response = yield this.sendRequest(tmsQueryParams, authToken, "TmsServiceUrl" /* tmsServiceUrl */, TmsgConstants.TMS_SERVICEURL);
        if (response.status === 200) {
          const tmsServiceResponse = yield response.json();
          if (contentTypes.indexOf("MessageMetadata" /* messageMetadata */) !== -1 && tmsServiceResponse.MessageMetadata !== undefined) {
            this.tmsgCache.setContentItem("MessageMetadata" /* messageMetadata */, tmsServiceResponse.MessageMetadata, getDynamicSetting("TmsMessageMetadataExpiry" /* tmsMessageMetadataExpiry */, TmsgConstants.CACHE_EXPIRY_MESSAGEMETADATA));
          }
          if (contentTypes.indexOf("UserGovernance" /* userGovernanceRules */) !== -1 && tmsServiceResponse.UserGovernanceRules !== undefined) {
            this.tmsgCache.setContentItem("UserGovernance" /* userGovernanceRules */, tmsServiceResponse.UserGovernanceRules, getDynamicSetting("TmsUserGovernanceRulesExpiry" /* tmsUserGovernanceRulesExpiry */, TmsgConstants.CACHE_EXPIRY_USERGOVERNANCERULES));
          }
          if (contentTypes.indexOf("CampaignContent" /* campaignContent */) !== -1 && tmsServiceResponse.CampaignContent !== undefined) {
            this.tmsgCache.setContentItem("CampaignContent" /* campaignContent */, tmsServiceResponse.CampaignContent, getDynamicSetting("TmsCampaignContentExpiry" /* tmsCampaignContentExpiry */, TmsgConstants.CACHE_EXPIRY_CAMPAIGNCONTENT));
          }
          // There is no explicit request for the next set of ContentTypes in the code
          // If the server responds with these types save and use them later
          if (tmsServiceResponse.DynamicSettings !== undefined) {
            this.tmsgCache.setContentItem("DynamicSettings" /* dynamicSettings */, tmsServiceResponse.DynamicSettings, getDynamicSetting("TmsDynamicSettingsExpiry" /* tmsDynamicSettingsExpiry */, TmsgConstants.CACHE_EXPIRY_DYNAMICSETTINGS));
          }
          if (tmsServiceResponse.LogLevelSettings !== undefined) {
            this.tmsgCache.setContentItem("LogLevelSettings" /* logLevelSettings */, tmsServiceResponse.LogLevelSettings, getDynamicSetting("TmsLogLevelSettingsExpiry" /* tmsLogLevelSettingsExpiry */, TmsgConstants.CACHE_EXPIRY_LOGLEVELSETTINGS));
          }
          Logging.getLogger().logEvent(Logging.EventIds.WebSurfaces.Messaging.Requests.VALUE, 3 /* Info */, this.createTelemetryData(requestStartTime, response, contentTypes.join(";")));
        } else {
          Logging.getLogger().logEvent(Logging.EventIds.WebSurfaces.Common.Error.VALUE, 2 /* Error */, this.createTelemetryData(requestStartTime, response, contentTypes.join(";")));
        }
      } catch (error) {
        Logging.getLogger().logEvent(Logging.EventIds.WebSurfaces.Common.Error.VALUE, 2 /* Error */, Object.assign({
          ErrorMessage: "Error fetching from TMS" + (error && error.message ? ": " + error.message : "")
        }, this.createTelemetryData(requestStartTime, null, contentTypes.join(";"))));
      }
    });
  }
  refreshItemsInCacheFromTulipsService(contentType) {
    return __awaiter(this, void 0, void 0, function* () {
      // check if touched item is actually due for refresh or is still valid
      if (!this.tmsgCache.isItemExpired(contentType)) {
        // exit out if the cache is still valid to avoid unnecessary service roundtrips
        return;
      }
      const tulipsAppId = getDynamicSetting("TulipsAppId" /* tulipsAppId */, Constants.GUIDs.TULIPSAppID);
      const authToken = yield this.getAuthToken(tulipsAppId);
      if (!authToken) {
        // if authToken is null then exit out since service call cannot be made without authToken
        return;
      }
      const requestStartTime = +new Date();
      // make service call for expired or uncached item
      try {
        const response = yield this.sendRequest({}, authToken, "TulipsServiceUrl" /* tulipsServiceUrl */, TmsgConstants.TULIPS_SERVICEURL);
        if (response.status === 200 || response.status === 204) {
          const tulipsServiceResponse = yield response.json();
          if (contentType.indexOf("UserFacts" /* userFacts */) !== -1 && tulipsServiceResponse !== undefined) {
            const normalizedUserFacts = this.addClientIngestionTimeAndNormalizeKeys(tulipsServiceResponse);
            this.tmsgCache.setContentItem("UserFacts" /* userFacts */, normalizedUserFacts, TmsgConstants.CACHE_EXPIRY_USERFACTS);
          }
          Logging.getLogger().logEvent(Logging.EventIds.UserFacts.Messaging.Requests.VALUE, 3 /* Info */, this.createTelemetryData(requestStartTime, response, contentType));
        } else {
          Logging.getLogger().logEvent(Logging.EventIds.UserFacts.Common.Error.VALUE, 2 /* Error */, this.createTelemetryData(requestStartTime, response, contentType));
        }
      } catch (error) {
        Logging.getLogger().logEvent(Logging.EventIds.UserFacts.Common.Error.VALUE, 2 /* Error */, Object.assign({
          ErrorMessage: "Error fetching from TULIPS" + (error && error.message ? ": " + error.message : "")
        }, this.createTelemetryData(requestStartTime, null, contentType)));
      }
    });
  }
  addClientIngestionTimeAndNormalizeKeys(tulipsServiceResponse) {
    const currentDateTime = new Date(Date.now()).toISOString();
    return tulipsServiceResponse.map(responseFact => {
      const fact = this.normalizeKeys(responseFact);
      fact.clientIngestionDateTime = currentDateTime;
      return fact;
    });
  }
  addClientIngestionTimeAndNormalizeKeysInArray(userFacts) {
    const currentDateTime = new Date(Date.now()).toISOString();
    return userFacts.map(userFact => {
      const fact = this.normalizeKeys(userFact);
      fact.clientIngestionDateTime = currentDateTime;
      return fact;
    });
  }
  /**
   * This method normalizes the keys of the user fact object retrieved from the TULIPS service.
   * Specifically it converts the first letter of each key in the object to lower case.
   * For example the key "UserFactType" returned from the service will be converted to "userFactType".
   * @param userFact the user fact object
   */
  normalizeKeys(userFact) {
    const normalizedUserFact = {};
    for (const key of Object.keys(userFact)) {
      const normalizedKey = key.charAt(0).toLowerCase() + key.substring(1);
      normalizedUserFact[normalizedKey] = userFact[key];
    }
    return normalizedUserFact;
  }
}